import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import TextField from "../Reusable/TextField";
import ImageField from "../Reusable/ImageField";
import { RichTextEditor } from "../Reusable/RichTextEditor";
import { ICategorySchema } from "../../utils/validationSchema";

interface ICreateCategoryForm {
  register: UseFormRegister<ICategorySchema>;
  setValue: UseFormSetValue<ICategorySchema>;
  getValues: UseFormGetValues<ICategorySchema>;
  errors: FieldErrors<ICategorySchema>;
  clearErrors?: UseFormClearErrors<ICategorySchema>;
  control: Control<ICategorySchema>;
}

const CreateCategoryForm = ({
  register,
  setValue,
  errors,
  control,
}: ICreateCategoryForm) => {
  return (
    <div
      className={tw`grid grid-cols-2 gap-2`}
      style={{
        gridTemplateColumns: "1.3fr 2fr",
      }}
    >
      <div className={tw`px-2 border-r`}>
        <TextField
          placeholder="Enter a Category"
          type="text"
          label="Category Name"
          register={register("name", {
            required: "Name is required",
          })}
          errors={errors.name}
        />
        <ImageField
          label="Preview Image"
          name="preview_image"
          control={control}
        />
      </div>
      <RichTextEditor
        register={register("description")}
        setValue={setValue}
        errors={errors.description}
        label="Description"
        registeredKey="description"
        name="description"
        control={control}
      />
    </div>
  );
};

export default CreateCategoryForm;
